import { Dialog, DialogContent, Stack, Typography, Box } from '@mui/material';

import { PanelHeader } from '@/components/panels/panelHeader';

import QueryResultsTable from './QueryResultsTable';

export function TableDataPreviewDialog({
  data,
  onClose,
  isLoading,
}: {
  data: { headers: string[]; rows: string[][] };
  onClose: () => void;
  isLoading: boolean;
}) {
  return (
    <Dialog
      open={true}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: '100%',
          height: '100%',
        },
      }}
      onClose={onClose}
    >
      <PanelHeader onClose={onClose} title='Preview sample records' />
      <>
        <DialogContent>
          <Stack gap='24px'>
            <Stack
              direction='row'
              justifyContent='space-between'
              alignItems='center'
            >
              <Typography variant='body1'>
                {`Showing a sample of ${data?.rows.length} records.`}
              </Typography>
            </Stack>
            <Box className='relative'>
              <QueryResultsTable
                loading={isLoading}
                headerColumns={data?.headers}
                data={data?.rows}
              />
            </Box>
          </Stack>
        </DialogContent>
      </>
    </Dialog>
  );
}
